module.exports = __webpack_public_path__ + "media/images/icon-comm-disabled-ba50c5767a09f54d54b8eaeaf056a046.svg";